class TrackingService {
    constructor() {
        if (new.target === TrackingService) {
            throw new Error("Cannot instantiate abstract class");
        }

        if (this.trackEvent === TrackingService.prototype.trackEvent) {
            throw new Error("Must implement trackEvent method");
        }

        if (this.identify === TrackingService.prototype.identify) {
            throw new Error("Must implement identify method");
        }

        if (this.setUserProperties === TrackingService.prototype.setUserProperties) {
            throw new Error("Must implement setUserProperties method");
        }

        if (this.identifyOnce === TrackingService.prototype.identifyOnce) {
            throw new Error("Must implement identifyOnce method");
        }
    }

    trackEvent(eventName, properties) {
        throw new Error("Method 'trackEvent(eventName, properties)' must be implemented");
    }

    identify(userId, properties) {
        throw new Error("Method 'identify(userId, properties)' must be implemented");
    }

    identifyOnce(userId, properties) {
        throw new Error("Method 'identifyOnce(userId, properties)' must be implemented");
    }

    setUserProperties(properties) {
        throw new Error("Method 'setUserProperties(properties)' must be implemented");
    }
}

export default TrackingService;